import { format, parse, isValid } from "date-fns"

export function formatCurrency(value, currency = "INR", fractional = false) {

    try {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency,
            minimumFractionDigits: fractional ? 2 : 0,
            maximumFractionDigits: 2,
        }).format(value);
    } catch (error) {
        return value
    }

}

const CURRENCY_SYMBOLS = {
    INR: 'Rs.',
    USD: '$',
    EUR: 'EUR',
    GBP: 'GBP',
    AED: 'AED',
    SGD: 'SGD',
};

export const formatCurrencyPDF = (value, currency = 'INR') => {
    try {
        const symbol = CURRENCY_SYMBOLS[currency] ?? currency;
        const formatted = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(Number(value) || 0);
        return `${symbol} ${formatted}`;
    } catch {
        return String(value);
    }
};

export const formatDateYMD = (dateString) => {

    try {

        const date = new Date(dateString)
        return format(date, "yyyy-MM-dd")

    } catch (error) {
        return dateString
    }

}

export const formatDateMD = (dateString) => {

    try {

        const date = new Date(dateString)
        return format(date, "MMM dd")

    } catch (error) {
        return dateString
    }

}

export const formatDate = (d) => new Date(d)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

export const convertTo24HourWithSeconds = (time12h) => {
    try {
        if (!time12h) throw new Error("Time is required");

        const parsedTime = parse(time12h, "hh:mm a", new Date());


        if (!isValid(parsedTime)) {
            throw new Error("Invalid time format");
        }

        return format(parsedTime, "HH:mm:ss");
    } catch (error) {
        console.error("Time conversion failed:", error.message);
        return null;
    }
};

export const convertTo12Hour = (time24h) => {
    try {
        if (!time24h) throw new Error("Time is required");

        const parsedTime = parse(time24h, "HH:mm:ss", new Date());

        if (!isValid(parsedTime)) {
            throw new Error("Invalid time format");
        }

        return format(parsedTime, "hh:mm a");

    } catch (error) {
        console.error("Time conversion failed:", error.message);
        return null;
    }
};